import React from 'react';

export class HelpMenu extends React.Component {
    renderItem = (item, index) => {
        return (
            <a className="site-header-tray__menu-item-link site-header-tray__menu-item-link--help" data-bypass="true" href={item.link} key={`link-${index}`} target="_blank">{item.text}</a>
        );
    }

    render() {
        return (
            <div className="site-header-tray__menu site-header-tray__drawer">
                <div className="site-header-tray__items">
                    {this.props.help.items.map(this.renderItem)}
                </div>
            </div>
        );
    }
}
